import script from "./ErrorDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorDialog.vue?vue&type=style&index=0&id=5771cfae&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1078960470/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5771cfae"]])

export default __exports__